"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _constants = require("../constants");
/**
 * Função depreciada na versão 1.5.0
 */
var _default = exports["default"] = function _default() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }
  return values.map(function (value) {
    if (typeof value === 'string') {
      return value;
    }
    return "".concat(_constants.SPACING * value, "px");
  }).join(' ');
};